module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.79/css/toolsmenu.css"